import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

interface LoadingScreenProps {
  /** 'full' = viewport (boot gate); 'inline' = inside shell (route fallback). */
  variant?: 'full' | 'inline';
}

// Hard-coded (not i18n): boot gate renders before translations load.
const srOnly = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
} as const;

/** Loading state: boot gate (config + i18n) and lazy-route fallback. */
const LoadingScreen = ({ variant = 'full' }: LoadingScreenProps) => (
  <Box
    role="status"
    aria-live="polite"
    aria-busy="true"
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 3,
      ...(variant === 'full'
        ? { minHeight: '100dvh', bgcolor: 'background.default' }
        : { flex: 1, minHeight: 240 }),
    }}
  >
    <CircularProgress aria-hidden />
    <Box component="span" sx={srOnly}>
      Loading…
    </Box>
  </Box>
);

export default LoadingScreen;
